import { createAction } from '../../../store.model';
import { ActionType } from '../landing.action';
import { GridType } from '../model/grid-type.model';

export interface ResetGrid {
    grid: GridType;
}

export const resetGrid = createAction<ActionType, ResetGrid>(
    ActionType.EVAL_LANDING__RESET_GRID,
);
